const table104 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "sales_amount",
        name: "売上金額",
        editable: true
    },
    {
        key: "submission_article_30",
        name: "税理士法第30条の書面提出",
        editable: true
    },
    {
        key: "submission_article_30_2",
        name: "税理士法第33条の2の書面提出",
        editable: true
    },
    {
        key: "business_exempted_act_42",
        name: "措法42の4⑲八の適用除外事業者",
        editable: true
    },
    {
        key: "loss_carryforward_deductible_limit",
        name: "繰越欠損金の損金算入限度額",
        editable: true
    },
    {
        key: "additional_amount_disguised_accounting",
        name: "税額加算額_仮装経理の加算額",
        editable: true
    },
    {
        key: "additional_amount_other",
        name: "税額加算額_上記以外の加算額",
        editable: true
    },
    {
        key: "taxable_land_transfer_profit_amount",
        name: "土地譲渡_課税土地譲渡利益金額",
        editable: true
    },
    {
        key: "taxamount_for_the_same",
        name: "土地譲渡_同上に対する税額",
        editable: true
    },
    {
        key: "beneficiary_concealed_disbursement",
        name: "使途秘匿金の支出額",
        editable: true
    },
    {
        key: "disguised_accounting_corporate",
        name: "仮装経理の控除税額_法人税分",
        editable: true
    },
    {
        key: "disguised_accounting_local_corporate",
        name: "仮装経理の控除税額_地方法人税分",
        editable: true
    },
    {
        key: "deductible_income_tax_amount_foreign_company_corporate",
        name: "外国関係会社等に係る控除対象所得税額等相当額の控除額_法人税分",
        editable: true
    },
    {
        key: "deductible_income_tax_amount_foreign_company_local_corporate",
        name: "外国関係会社等に係る控除対象所得税額等相当額の控除額_地方法人税分",
        editable: true
    },
    {
        key: "foreign_tax_corporate",
        name: "当期に控除できる外国税額_法人税分",
        editable: true
    },
    {
        key: "foreign_tax_local_corporate",
        name: "当期に控除できる外国税額_地方法人税分",
        editable: true
    },
    {
        key: "date_final_distribution_or_transfer_era",
        name: "残余財産の最後の分配又は引渡しの日_元号",
        editable: true
    },
    {
        key: "date_final_distribution_or_transfer",
        name: "残余財産の最後の分配又は引渡しの日",
        editable: true,
        type: "date"
    },
    {
        key: "date_definite_settlement_era",
        name: "決算確定の日_元号",
        editable: true
    },
    {
        key: "date_definite_settlement",
        name: "決算確定の日",
        editable: true,
        type: "date"
    },
    {
        key: "balance_sheet",
        name: "貸借対照表",
        editable: true
    },
    {
        key: "profit_loss",
        name: "損益計算書",
        editable: true
    },
    {
        key: "equity_or_profit_loss",
        name: "株主(社員)資本等変動計算書又は損益金処分表",
        editable: true
    },
    {
        key: "items_of_accounts",
        name: "勘定科目内訳明細書",
        editable: true
    },
    {
        key: "business_summary_statement",
        name: "事業概況書",
        editable: true
    },
    {
        key: "agreement_reorganization",
        name: "組織再編成に係る契約書等の写し",
        editable: true
    },
    {
        key: "agreement_transfer_asset",
        name: "組織再編成に係る移転資産等の明細書",
        editable: true
    }
];

export { table104 };
